import React from "react";
import Events from "components/events";
import Icons from "components/icons";
import { Localize } from "components/service";


const StaffManagementQrField = ({ event }) => (
    event?.getCheckQrCodeUrl ?
        <div className="d-flex justify-content-end staff-management-list__qr-action">
            <Events.Actions.Fields.CheckQrGenerate
                event={ event }
                eventID={ event.id }
                icon={ <Icons.StaffQrCode /> }
                label={ <Localize>STAFF_MANAGEMENT.Action_CheckInQr</Localize> }
                modalTitle={ <Localize>STAFF_MANAGEMENT.Modal_CheckInQr</Localize> }
                buttonClassName="btn-icon-text btn-text-link"
                variant="staff-management" />
        </div> :
        <span className="staff-management-list__no-qr">
            <Localize>STAFF_MANAGEMENT.Action_NoQr</Localize>
        </span>
);

export default StaffManagementQrField;
